// iter86.68 — Team displays only render TRUE national/subdivision flag
// emojis (🇺🇸, 🏴󠁧󠁢󠁥󠁮󠁧󠁿). Generic sport/club icons (🏈 ⚽ 🏳️) are dropped to
// save space (user request: keep flags for golf/WC, remove the rest).
const RI_FLAG = /^(?:\uD83C[\uDDE6-\uDDFF]){2}$/;
const SUBDIV_FLAG = /^\uD83C\uDFF4(?:\uDB40[\uDC20-\uDC7E])+\uDB40\uDC7F$/;

export function nationalFlag(f) {
    const s = (f || "").trim();
    return RI_FLAG.test(s) || SUBDIV_FLAG.test(s) ? s : null;
}
